const { NodeTypes } = require("es-html-parser");

const NODE_TYPES = NodeTypes;

module.exports = {
  NODE_TYPES,
};
